import { type QuoteBranch } from '../../../modules/quotes/core/models/subModels/quoteBranch.model'
import { GoogleRating, MovingWaldoRating } from '../../Rating'

type CompanyRatingsProps = {
  branch: QuoteBranch
}

const CompanyRatings: React.FC<CompanyRatingsProps> = ({ branch }) => {
  if (!branch.ratings) {
    return null
  }

  if (branch.ratings.movingWaldo) {
    return (
      <MovingWaldoRating
        small
        companyBranch={{
          id: branch.id,
          identification: { name: branch.name },
          company: {
            id: branch.id,
            identification: { name: branch.name },
            logo: branch.logo?.en ? { en: branch.logo.en } : undefined,
          },
          ratings: branch.ratings,
        }}
        withReviewsModal
      />
    )
  }

  if (branch.ratings.google) {
    return (
      <GoogleRating
        small
        {...branch.ratings.google}
      />
    )
  }

  return null
}

export default CompanyRatings
